import { BaseErrorForm } from "@hub/common/BaseErrorForm";
import { NG_VALUE_ACCESSOR } from "@angular/forms";
import { OnInit, OnDestroy, forwardRef, Component, Input } from "@angular/core";
import { FormEventService } from '@hub/services/form-event.service';

export const CUSTOM_HYPERLINK_VALUE_ACCESSOR: any = {
	provide: NG_VALUE_ACCESSOR,
	useExisting: forwardRef(() => FormHyperlinkComponent),
	multi: true
};
@Component({
    selector: 'fm-hyperlink',
    templateUrl: './form-hyperlink.component.html',
    // providers: [CUSTOM_HYPERLINK_VALUE_ACCESSOR]
  })
export class FormHyperlinkComponent extends BaseErrorForm
  implements OnInit, OnDestroy {
  constructor(
    public formEventService: FormEventService
  ) { super(); }

  @Input() label = null;
  @Input() urlAddress = null;

  ngOnInit() {
  }

  ngOnDestroy() {

  }

  }